/* eslint eqeqeq: "off" */
import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import {
  Col,
  Row,
 
  Table,
  Input,
  Spin,
  Upload,
  Button,
  Typography,
  Image,
  Tooltip,
  // Badge,
} from "antd";
import {
  MinusOutlined,
  //PlusCircleOutlined,
  UploadOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import "./index.css";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { isEmpty } from "lodash";
import useMedia from "use-media-antd-query";
import {
  // loadAccountLedgerReportList,
  loadTicketingDetails,
  loadTicketReplyList,
} from "../../store/reports/actions";
import api from "../../helpers";
import { GiOpenFolder } from "react-icons/gi";
import { SiProgress } from "react-icons/si";
import { RiMailCloseFill } from "react-icons/ri";
import { MdAttachment, MdPendingActions } from "react-icons/md";
import { useHistory } from "react-router";
import { toast, ToastContainer } from "react-toastify";
import { FaHandHolding } from "react-icons/fa6";

const TicketingDetails = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();

  //organisation id from login response
  const userValues = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userValues);

  const organizationId =
    !isEmpty(userNameDetails) &&
    userNameDetails.user &&
    userNameDetails.user.organizations.length > 0
      ? userNameDetails.user.organizations[0].organizationId
      : "";
  const userId =
    !isEmpty(userNameDetails) &&
    userNameDetails.user &&
    userNameDetails.user !== undefined
      ? userNameDetails.user._id
      : "";

  const media = useMedia();



  //initial state values
  const [loading, setLoading] = useState(false);
  const [filterOpen, setFilterOpen] = useState(true);
  const [tableLoading, setTableLoading] = useState(false);
  const [descriptions, setDescriptions] = useState("");
  const [filterMode, setFilterMode] = useState({ value: "", label: "" });

  useEffect(() => {
    setLoading(true);
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
      setLoading(false);
    }, 2000);

    dispatch(loadTicketingDetails());

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // reducer state
  const { ticketing_details_report = [], ticket_reply_list = [] } = useSelector(
    (state) => state.Reports
  );
  console.log(ticket_reply_list, "ticket_reply_list");
  //header columns
  const headerData = [
    {
      key: "attachment",
      title: <p className="header-purchase-invoice font-semibold"></p>,
      dataIndex: "attachment",
      width: 80,
      // fixed: "left",
      render: (row, text) => (
        <p
          className="ml-1"
          style={{
            fontFamily: "Poppins",
            fontSize: "12px",
          }}
        >
          {text.attachment && text.attachment}
        </p>
      ),
      //   sorter: (a, b) => a.subject.length - b.subject.length,
    },
    {
      key: "action",
      title: <p className="header-purchase-invoice font-semibold">Action</p>,
      dataIndex: "action",
      width: 80,
      //   sorter: (a, b) => a.subject.length - b.subject.length,
    },
    {
      key: "categoryName",
      title: <p className="header-purchase-invoice font-semibold">Category</p>,
      dataIndex: "categoryName",
      width: 150,
      // fixed: "left",
      render: (row, text) => (
        <p
          className="ml-1"
          style={{
            fontFamily: "Poppins",
            fontSize: "12px",
          }}
        >
          {text.categoryName && text.categoryName}
        </p>
      ),
      //   sorter: (a, b) => a.subject.length - b.subject.length,
    },
    {
      key: "description",
      title: (
        <p className="header-purchase-invoice font-semibold">Description</p>
      ),
      dataIndex: "description",
      width: 220,
      // fixed: "left",
      render: (row, text) => (
        <p
          className="ml-1"
          style={{
            fontFamily: "Poppins",
            fontSize: "12px",
          }}
        >
          {text.description && text.description}
        </p>
      ),
      //   sorter: (a, b) => a.subject.length - b.subject.length,
    },
    {
      key: "priority",
      title: <p className="header-purchase-invoice font-semibold">Priority</p>,
      dataIndex: "priority",
      width: 120,
      // fixed: "left",
      render: (row, text) => (
        <p
          className="ml-1"
          style={{
            fontFamily: "Poppins",
            fontSize: "12px",
          }}
        >
          {text.priority && text.priority}
        </p>
      ),
      //   sorter: (a, b) => a.subject.length - b.subject.length,
    },
    {
      key: "status",
      title: <p className="header-purchase-invoice font-semibold">Status</p>,
      dataIndex: "status",
      width: 150,
      // fixed: "left",
      render: (row, text) => (
        <p
          className="ml-1"
          style={{
            fontFamily: "Poppins",
            fontSize: "12px",
          }}
        >
          {text.status && text.status}
        </p>
      ),
      //   sorter: (a, b) => a.subject.length - b.subject.length,
    },
    {
      key: "lastReplier",
      title: (
        <p className="header-purchase-invoice font-semibold">Last Replier</p>
      ),
      render: (row, text) => (
        <p className="flex">
          <p
            style={{
              fontFamily: "Poppins",
              fontSize: "12px",
            }}
            className="ml-1 mt-[0.15rem]"
          >
            {text.lastReplier ? text.lastReplier.toLocaleString("en-IN") : 0}
          </p>
        </p>
      ),
      dataIndex: "lastReplier",
      width: 160,
    },
    {
      key: "updatedAt",
      title: (
        <p className="header-purchase-invoice font-semibold">Last Activity</p>
      ),
      render: (row, text) => (
        <p className="flex">
          <p
            style={{
              fontFamily: "Poppins",
              fontSize: "12px",
            }}
            className="ml-1 mt-[0.15rem]"
          >
            {text.updatedAt ? text.updatedAt : 0}
          </p>
        </p>
      ),
      dataIndex: "updatedAt",
      width: 160,
    },
  ];

  const HeaderData =
    filterMode && filterMode.value === 3
      ? headerData.filter((data) => data.key !== "action")
      : headerData;

  //filters
  // const [pageValue, setPageValue] = useState("");
  // const [filteredValues, setFilteredValues] = useState("");
  const [selectedTickets, setSelectedTickets] = useState("");

  const [ticketingDetails, setTicketingDetails] = useState([
    {
      key: "",
      attachment: "",
      categoryId: "",
      categoryName: "",
      createdBy: "",
      description: "",
      organizationId: "",
      priority: "",
      status: "",
      lastReplier: "",
      userId: "",
      createdAt: "",
      updatedAt: "",
      _id: "",
    },
  ]);

  const ticketingDetailsTable =
    !isEmpty(ticketing_details_report) && ticketing_details_report.length > 0
      ? ticketing_details_report.map((data, index) => {
          return {
            key: index + 1,
            attachment: (
              <div
                className="cursor-pointer text-[18px]"
                onClick={() => window.open(data.attachment, "_blank")}
              >
                <MdAttachment />
              </div>
            ),
            categoryId: data.categoryId,
            categoryName: (
              <div
                onClick={() => {
                  setSelectedTickets(data);

                  if (data.status === "open") {
                    api
                      .post("/org/clickintoticket", {
                        organizationId: organizationId,
                        ticketId: data._id,
                        updatedBy: userId,
                      })
                      .then((res) => {
                        setFilterMode({
                          value: "2",
                          label: "Inprogress",
                        });
                        return res.data;
                      })
                      .catch((error) => {
                        return Promise.reject(error);
                      });
                    dispatch(
                      loadTicketReplyList({
                        organizationId: data.organizationId,
                        ticketId: data._id,
                      })
                    );
                    dispatch(
                      loadTicketingDetails({
                        // organizationId: organizationId,
                        status: "2",
                      })
                    );
                  } else {
                    dispatch(
                      loadTicketReplyList({
                        organizationId: data.organizationId,
                        ticketId: data._id,
                      })
                    );
                  }
                }}
                className="underline cursor-pointer text-[14px]"
              >
                {data.categoryName}
              </div>
            ),
            createdBy: data.createdBy,
            description: data.description,
            organizationId: data.organizationId,
            priority: (
              <div
                className={
                  data.priority && data.priority === "low"
                    ? "w-[60%] capitalize text-center bg-[#edf6ef] font-semibold header-sales-invoice rounded-md text-[#49a563] text-[12px] p-1"
                    : data.priority && data.priority === "medium"
                    ? "w-[60%] capitalize text-center bg-[#edf6ef] font-semibold header-sales-invoice rounded-md text-[#49a563] text-[12px] p-1"
                    : "w-[60%] capitalize text-center bg-[#f1e7e9] font-semibold header-sales-invoice rounded-md text-[#d01717] text-[12px] p-1"
                }
              >
                {data.priority}
              </div>
            ),
            status: (
              <div
                className={
                  data.status && data.status === "inprogress"
                    ? "w-[70%] capitalize text-center bg-[#0ba5ec] font-semibold header-sales-invoice rounded-md text-[#49a563] text-[12px] p-1"
                    : data.status && data.status === "open"
                    ? "w-[70%] capitalize text-center bg-[#edf6ef] font-semibold header-sales-invoice rounded-md text-[#49a563] text-[12px] p-1"
                    : data.status && data.status === "pending"
                    ? "w-[70%] capitalize text-center bg-[#edf6ef] font-semibold header-sales-invoice rounded-md text-[#49a563] text-[12px] p-1"
                    : "w-[70%] capitalize text-center bg-[#f1e7e9] font-semibold header-sales-invoice rounded-md text-[#d01717] text-[12px] p-1"
                }
              >
                {data.status}
              </div>
            ),
            // status: data.status,
            userId: data.userId,
            lastReplier: data.userName !== undefined ? data.userName : "--",
            createdAt: data.createdAt
              ? moment(data.createdAt).format("DD-MM-YYYY")
              : "",
            action: (
              <Tooltip placement="top" title="Close Ticket">
                <RiMailCloseFill
                  className="text-[#e74c3c] text-[18px] cursor-pointer"
                  onClick={() => {
                    api
                      .post("/org/updatestatusbyuser", {
                        organizationId: organizationId,
                        ticketId: data._id,
                        status: 3,
                        updatedBy: userId,
                      })
                      .then((res) => {
                        toast.success("Status updated successfully");
                        dispatch(
                          loadTicketingDetails({
                            // organizationId: organizationId,
                            status:
                              filterMode !== undefined && filterMode.value,
                          })
                        );
                        return res.data;
                      })
                      .catch((error) => {
                        return Promise.reject(error);
                      });
                  }}
                />
              </Tooltip>
            ),
            updatedAt: data.updatedAt
              ? moment(data.updatedAt).format("DD-MM-YYYY")
              : "",
            _id: data._id,
          };
        })
      : [];

  useEffect(() => {
    if (ticketingDetailsTable && ticketingDetailsTable.length > 0) {
      setTicketingDetails(ticketingDetailsTable);
    } else {
      setTicketingDetails([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ticketing_details_report]);

  //paginations
  const handlePagination = (page, pageSize) => {
    const filter = {
      page: page,
      limit: pageSize,
      organizationId: organizationId,
      // partyId: filteredValues ? filteredValues.partyId : "",
      // paymentModeId: filteredValues ? filteredValues.paymentModeId : "",
      // transactionType: filteredValues ? filteredValues.transactionType : "",
      // fromDate: filteredValues ? filteredValues.fromDate : "",
      // toDate: filteredValues ? filteredValues.toDate : "",
    };
    const searchFilterValues = Object.keys(filter).forEach(
      (data) => !filter[data] && delete filter[data]
    );
    console.log(searchFilterValues, "searchFilterValues");
  //  setPageValue(page);
    // dispatch(loadAccountLedgerReportList(filter));
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
  };

  //image state

  const [fileList, setFileList] = useState([]);
  //Image upload
  const handleImageChange = ({ fileList: newFileList }) => {
    var fileArrayDetails =
      newFileList && newFileList.length > 0 ? newFileList[0].originFileObj : "";
    // var teamUploadValue = fileList;
    var formData = new FormData();
    formData.append("file", fileArrayDetails);
    setLoading(true);

    setTimeout(() => {
      api
        .post(`/img/upload`, formData)
        .then(async (res) => {
          if (res && res.data) {
            // teamUploadValue.push(res.data);
            // toast.success("Image Uploaded successfully");
            // setPreviewImage(res.data.file);
            setTimeout(() => {
              setLoading(false);
            }, 2000);
            await setFileList([res.data.file]);
          }
        })
        .catch((error) => {
          toast.error(
            `${
              !isEmpty(error) && error.response && error.response.data
                ? error.response.data.error
                : ""
            }`
          );
          setTimeout(() => {
            setLoading(false);
          }, 2000);
        });
    }, 1000);
  };

  //window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // quick filters
  const quickFilters = [
    // { value: "New Ticket", label: "New Ticket", icon: <PlusCircleOutlined /> },
    {
      value: "1",
      label: "Open",
      icon: <GiOpenFolder className="text-[#12b76ae0]" />,
    },
    {
      value: "2",
      label: "Inprogress",
      count: 7,
      icon: <SiProgress className="text-[#0ba5ec]" />,
    },
    {
      value: "3",
      label: "Resolved",
      count: 1,
      icon: <RiMailCloseFill className="text-[#e74c3c]" />,
    },
    {
      value: "4",
      label: "On-Hold",
      count: 1,
      icon: <FaHandHolding className="text-[#e74c3c]" />,
    },
    {
      value: "5",
      label: "Pending",
      count: 1,
      icon: <MdPendingActions className="text-[#e5bc16]" />,
    },
  ];

  //post reply
  const postReplyDetails = () => {
    const obj = {
      organizationId:
        selectedTickets !== undefined ? selectedTickets.organizationId : "",
      description: descriptions,
      createdBy: userId,
      attachment: fileList.length > 0 ? fileList[0] : "",
      ticketId: selectedTickets !== undefined ? selectedTickets._id : "",
      userId: userId,
      categoryId:
        selectedTickets !== undefined ? selectedTickets.categoryId : "",
      isAdmin: true,
    };
    api
      .post("/org/createpr", obj)
      .then((res) => {
        // toast.success("Tickets created successfully");
        dispatch(
          loadTicketReplyList({
            organizationId:
              selectedTickets !== undefined
                ? selectedTickets.organizationId
                : "",
            ticketId: selectedTickets !== undefined && selectedTickets._id,
          })
        );
        setFileList([]);
        setDescriptions("");
        return res.data;
      })
      .catch((error) => {
        const errorMsg =
          (error &&
            error.response &&
            error.response.data &&
            error.response.data.message) ||
          (error &&
            error.response &&
            error.response.data &&
            error.response.data.error);

        toast.error(
          errorMsg || "There is a an issue while adding the post reply"
        );
        Promise.reject(error);
      });
  };

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Ticket Details | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-sm bg-[#ffffff]">
        <Col span={24}>
          <div className="font-poppins border border-b-1 border-x-0 border-t-0 pl-[20px] pr-[20px] mt-2 pb-2">
            <div className="flex">
              <h1
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-[16px] font-semibold"
              >
                Ticket Details
              </h1>
            </div>
          </div>
        </Col>
      </Row>
      <Row
        className={
          (windowDimensions.height >= 700 && windowDimensions.height <= 767) ||
          (windowDimensions.height > 767 && windowDimensions.height < 830)
            ? "add-purchase-home-main-large-device bg-[white]"
            : windowDimensions.height > 830 && windowDimensions.height < 1000
            ? "add-purchase-home-extra-main-large-device bg-[white]"
            : windowDimensions.height > 1000
            ? "add-purchase-home-main-infinite-large-device bg-[white]"
            : "add-purchase-invoices-home-main bg-[white]"
        }
        // className="w-[100%]"
      >
        {/* print, download section */}
        <Col
          md={24}
          lg={24}
          sm={24}
          xs={24}
          className={
            windowDimensions.height > 700 &&
            windowDimensions.height < 830 &&
            ticketingDetailsTable.length > 0
              ? "mt-[1px] h-[80%] bg-[#ffffff] rounded-md"
              : windowDimensions.height > 830 &&
                windowDimensions.height < 1000 &&
                ticketingDetailsTable.length > 0
              ? "mt-[1px] h-[80%] bg-[#ffffff] rounded-md"
              : windowDimensions.height > 700 &&
                windowDimensions.height < 830 &&
                ticketingDetailsTable.length == 0
              ? "mt-[1px] h-[80%] bg-[#ffffff] rounded-md"
              : windowDimensions.height > 830 &&
                windowDimensions.height < 1000 &&
                ticketingDetailsTable.length == 0
              ? "mt-[1px] h-[80%] bg-[#ffffff] rounded-md"
              : windowDimensions.height >= 1000
              ? "mt-[1px] h-[80%] bg-[#ffffff] rounded-md"
              : "bg-[#ffffff] rounded-md"
          }
        >
          <Row
            className={
              media === "xxl"
                ? "flex flex-row mt-5 pl-4 purchase-invoice-orders bg-[#ffffff] pb-12 pr-4"
                : media === "md"
                ? "flex flex-row mt-5 pl-4 purchase-invoice-orders bg-[#ffffff] pb-12 pr-4"
                : "flex flex-row mt-5 pl-4 purchase-invoice-orders bg-[#ffffff] pb-[100px] pr-4"
            }
          >
            <Col
              md={6}
              lg={6}
              xl={6}
              xxl={6}
              sm={24}
              xs={24}
              className="mt-2 mb-3 pb-5 pr-4 "
            >
              <Row>
                <Col
                  md={24}
                  lg={24}
                  xl={24}
                  xxl={24}
                  sm={24}
                  xs={24}
                  className="border border-1 rounded-md shadow-sm"
                >
                  <Row>
                    <Col
                      md={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      sm={24}
                      xs={24}
                      className="border border-b-1 border-x-0 border-t-0"
                    >
                      <div className="flex justify-between w-[100%] p-3 font-label">
                        <p className="font-semibold">Filters</p>
                        {filterOpen ? (
                          <MinusOutlined onClick={() => setFilterOpen(false)} />
                        ) : (
                          <PlusOutlined onClick={() => setFilterOpen(true)} />
                        )}
                      </div>
                    </Col>
                    <>
                      {filterOpen
                        ? quickFilters.map((data, index) => {
                            return (
                              <Col
                                md={24}
                                lg={24}
                                xl={24}
                                xxl={24}
                                sm={24}
                                xs={24}
                                key={index}
                                className="border border-b-1 border-x-0 border-t-0 cursor-pointer"
                                onClick={() => {
                                  if (data.label === "New Ticket") {
                                    history.push("/ticketing/new-ticket");
                                  }
                                  setFilterMode({
                                    value: data.value,
                                    label: data.label,
                                  });
                                  dispatch(
                                    loadTicketingDetails({
                                      // organizationId: organizationId,
                                      status: data.value,
                                    })
                                  );
                                  setTableLoading(true);
                                  setTimeout(() => {
                                    setTableLoading(false);
                                  }, 1500);
                                }}
                              >
                                <div className="flex w-[100%] py-2 px-3 font-label">
                                  <h1
                                    className={
                                      data.label !== "New Ticket"
                                        ? "mt-[1px]"
                                        : ""
                                    }
                                  >
                                    {data.icon}
                                  </h1>
                                  <p className="ml-2">{data.label}</p>
                                </div>
                              </Col>
                            );
                          })
                        : ""}
                    </>
                  </Row>
                </Col>
              </Row>
            </Col>

            <Col md={18} lg={18} sm={24} xs={24} xl={18} xxl={18}>
              {" "}
              <Row>
                <Col
                  md={24}
                  lg={24}
                  sm={24}
                  xs={24}
                  xl={24}
                  xxl={24}
                  className="mt-2 mb-3 shadow-sm rounded-md border border-1"
                >
                  <div
                    className={
                      filterMode &&
                      filterMode.label !== undefined &&
                      filterMode.label !== ""
                        ? "pt-[20px] font-semibold text-[14px] font-label ml-4 mb-2"
                        : "pt-[40px] font-semibold text-[14px] font-label ml-4 mb-2"
                    }
                  >
                    {filterMode &&
                    filterMode.label !== undefined &&
                    filterMode.label !== ""
                      ? filterMode.label
                      : ""}
                  </div>
                  <Table
                    style={{
                      overflow: "hidden",
                    }}
                    bordered
                    columns={HeaderData}
                    dataSource={
                      ticketingDetails &&
                      ticketingDetails.length > 0 &&
                      !isEmpty(ticketingDetails[0]._id)
                        ? ticketingDetails
                        : []
                    }
                    rowClassName={"p-0"}
                    expandable={{
                      // expandedRowRender: expandedRowRender,
                      defaultExpandAllRows: false,
                      // expandIconColumnIndex: 5,
                    }}
                    pagination={{
                      defaultPageSize: 10,
                      showSizeChanger: true,
                      // onShowSizeChange: (e) => console.log(e, "page limit"),
                      pageSizeOptions: ["5", "10", "20", "30"],
                      onChange: (page, pageSize) =>
                        handlePagination(page, pageSize),
                      // page
                      total:
                        //   !isEmpty(search)
                        //     ? ticketingDetails.length
                        // :
                        ticketing_details_report &&
                        ticketing_details_report.pagination
                          ? ticketing_details_report.pagination.totalItems
                          : "",
                      showTotal: (total, pageSize) => {
                        const indexOfLastRow =
                          pageSize && pageSize.length > 0 && pageSize[1];
                        const indexOfFirstRow =
                          pageSize && pageSize.length > 0 && pageSize[0];

                        return (
                          <p
                            style={{
                              fontFamily: "Poppins",
                              fontSize: "12px",
                            }}
                          >
                            Showing rows {indexOfFirstRow} to {indexOfLastRow}{" "}
                            of{" "}
                            {
                              // !isEmpty(search)
                              //   ? ticketingDetails.length
                              //   :
                              ticketing_details_report &&
                              ticketing_details_report.pagination
                                ? ticketing_details_report.pagination.totalItems
                                : total
                            }
                          </p>
                        );
                      },
                    }}
                    sortDirections={"ascend"}
                    loading={tableLoading ? true : false}
                    showSorterTooltip={"sorter-icon"}
                    className="custom-header-table"
                    scroll={{
                      x: ticketingDetailsTable.length > 0 ? 1125 : "100%",
                    }}
                  />
                </Col>
                {selectedTickets !== "" ? (
                  <>
                    <Col
                      md={24}
                      lg={24}
                      sm={24}
                      xs={24}
                      xl={24}
                      xxl={24}
                      className="mt-2 mb-3 rounded-md shadow-sm border border-1"
                    >
                      <Row>
                        <Col
                          md={24}
                          lg={24}
                          xl={24}
                          xxl={24}
                          sm={24}
                          xs={24}
                          className=""
                        >
                          <div className="w-[100%] border border-b-1 border-[lightgray] border-x-0 border-t-0 flex px-5 py-3 font-label">
                            <h1 className="font-semibold text-[14px] ml-1 mt-1">
                              Post Reply
                            </h1>
                            {filterMode &&
                            filterMode.label !== undefined &&
                            filterMode.label !== "" ? (
                              <p
                                className={
                                  filterMode.label === "Open"
                                    ? "ml-3 cursor-pointer bg-[#12b76ae0] rounded-md text-[white] p-1 text-[12px]"
                                    : filterMode.label === "Inprogress"
                                    ? "ml-3 cursor-pointer bg-[#0ba5ec] rounded-md text-[white] p-1 text-[12px]"
                                    : filterMode.label === "Resolved"
                                    ? "ml-3 cursor-pointer bg-[#e74c3c] rounded-md text-[white] p-1 text-[12px]"
                                    : filterMode.label === "On-Hold"
                                    ? "ml-3 cursor-pointer bg-[#e74c3c] rounded-md text-[white] p-1 text-[12px]"
                                    : "ml-3 cursor-pointer bg-[#e5bc16] rounded-md text-[white] p-1 text-[12px]"
                                }
                              >
                                {filterMode.label}
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                        </Col>
                        <Col
                          md={24}
                          lg={24}
                          xl={24}
                          xxl={24}
                          sm={24}
                          xs={24}
                          className="px-5 py-3"
                        >
                          <Row>
                            <Col
                              md={24}
                              lg={24}
                              xl={24}
                              xxl={24}
                              sm={24}
                              xs={24}
                              className="w-[100%] mt-4 font-label"
                            >
                              <Typography className="flex font-label mb-1 text-[13px]">
                                Description
                              </Typography>

                              <Input.TextArea
                                value={descriptions}
                                onChange={(e) =>
                                  setDescriptions(e.target.value)
                                }
                                placeholder="Enter description"
                                // options={partyOptions}
                                style={{
                                  fontFamily: "Poppins",
                                  height: "180px",
                                }}
                                className={"w-[100%]"}
                              />
                            </Col>
                            <Col
                              md={24}
                              lg={24}
                              xl={24}
                              xxl={24}
                              sm={24}
                              xs={24}
                              className="w-[100%] mt-4 font-label"
                            >
                              <Typography className="flex mb-1 font-label text-[13px]">
                                Attachments
                              </Typography>

                              <Upload
                                // action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
                                // listType="picture-card"
                                fileList={fileList}
                                accept=".png, .jpeg"
                                maxCount={1}
                                // onPreview={handlePreview}
                                onChange={handleImageChange}
                                showUploadList={{
                                  showDownloadIcon: true,
                                  showRemoveIcon: true,
                                }}
                                beforeUpload={() => false}
                                onRemove={() => setFileList([])}
                              >
                                {fileList.length >= 1 ? (
                                  <Image
                                    preview={false}
                                    src={fileList[0]}
                                    height={170}
                                  />
                                ) : (
                                  <Button
                                    className="font-label w-[100%]"
                                    icon={<UploadOutlined />}
                                  >
                                    {loading ? (
                                      <div className="flex">
                                        <Spin className="mr-2" /> Uploading...
                                      </div>
                                    ) : (
                                      "Choose a file"
                                    )}
                                  </Button>
                                )}
                              </Upload>
                            </Col>
                            <Col
                              md={24}
                              lg={24}
                              xl={24}
                              xxl={24}
                              sm={24}
                              xs={24}
                              className="w-[100%] flex justify-center mt-10 border border-t-1 border-x-0 border-b-0 font-label"
                            >
                              <div
                                className={
                                  "w-[25%] mt-5 mb-5 flex justify-center border purchase-label text-[13px] bg-[#1a276dd4] hover:bg-[#7163c1] text-[#ffffff] rounded-sm ml-3 pl-8 pr-8 p-1.5 cursor-pointer"
                                }
                                style={{
                                  fontFamily: "Poppins",
                                }}
                                onClick={() => postReplyDetails()}
                              >
                                <p className="mt-[2px] text-[13px]">
                                  Post Reply
                                </p>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                    <Col
                      md={24}
                      lg={24}
                      sm={24}
                      xs={24}
                      xl={24}
                      xxl={24}
                      className="mt-2 mb-3 shadow-sm rounded-md border border-1"
                    >
                      <Row>
                        <Col
                          md={24}
                          lg={24}
                          xl={24}
                          xxl={24}
                          sm={24}
                          xs={24}
                          className=""
                        >
                          <div className="w-[100%] border border-b-1 border-[lightgray] border-x-0 border-t-0 flex px-5 py-3 font-label">
                            <h1 className="font-semibold text-[14px] ml-1 mt-1">
                              Ticket Replies
                            </h1>
                          </div>
                        </Col>
                        <Col
                          md={24}
                          lg={24}
                          xl={24}
                          xxl={24}
                          sm={24}
                          xs={24}
                          className=""
                        >
                          {ticket_reply_list && ticket_reply_list.length > 0 ? (
                            ticket_reply_list.map((data, index) => {
                              return (
                                <Row>
                                  <Col
                                    md={6}
                                    lg={6}
                                    xl={6}
                                    xxl={6}
                                    sm={24}
                                    xs={24}
                                    className={
                                      data.isUser === true
                                        ? "w-[100%] flex justify-center border border-r-1 border-b-1 border-t-0 border-l-0 pl-5 pt-4 pb-6 pr-4 font-label"
                                        : "bg-[#f5f5f5] w-[100%] flex justify-center border border-r-1 border-b-1 border-t-0 border-l-0 pl-5 pt-4 pb-6 pr-4 font-label"
                                    }
                                    key={index}
                                  >
                                    <div>
                                      <Typography className="font-label mb-1 text-[13px]">
                                        {data.userName !== undefined
                                          ? data.userName
                                          : ""}
                                      </Typography>

                                      <div
                                        className={
                                          data.isUser === true
                                            ? "mt-1 border rounded-md purchase-label text-[13px] bg-[gray] hover:bg-[lightgray] text-[#ffffff] pl-6 pr-6 cursor-pointer"
                                            : "mt-1 border rounded-md text-center purchase-label text-[13px] bg-[#1a276dd4] hover:bg-[#7163c1] text-[#ffffff] pl-6 pr-6 cursor-pointer"
                                        }
                                        style={{
                                          fontFamily: "Poppins",
                                        }}
                                      >
                                        <p className="mt-[2px] text-[13px] text-center">
                                          {data.isUser === true
                                            ? "User"
                                            : "Staff"}
                                        </p>
                                      </div>
                                    </div>
                                  </Col>
                                  <Col
                                    md={18}
                                    lg={18}
                                    xl={18}
                                    xxl={18}
                                    sm={24}
                                    xs={24}
                                    className="w-[100%] border border-b-1 border-x-0 border-t-0 font-label"
                                  >
                                    <div
                                      className={
                                        data.isUser === true
                                          ? "w-[100%] py-2 border border-b-1 border-x-0 border-t-0"
                                          : "w-[100%] bg-[#f5f5f5] py-2 border border-b-1 border-x-0 border-t-0"
                                      }
                                    >
                                      <Typography className="pl-3 pr-3 flex font-label mb-1 text-[12px]">
                                        Posted On:{" "}
                                        {data.createdAt !== undefined
                                          ? moment(data.createdAt).format(
                                              "MMMM Do YYYY, h:mm:ss a"
                                            )
                                          : ""}
                                      </Typography>
                                    </div>
                                    <div
                                      className={
                                        data.isUser === true
                                          ? "bg-[#fbfbfb] w-[100%] p-4"
                                          : "w-[100%] p-4"
                                      }
                                    >
                                      <Typography className="py-1 pl-3 pr-3 flex font-label text-[12px]">
                                        {data.description !== undefined
                                          ? data.description
                                          : ""}
                                      </Typography>
                                    </div>
                                  </Col>
                                </Row>
                              );
                            })
                          ) : (
                            <div className="flex justify-center w-[100%] border border-b-1 border-[lightgray] border-x-0 border-t-0 flex px-5 py-3 font-label">
                              <h1 className="text-[14px] ml-1 mt-1">
                                No Data found
                              </h1>
                            </div>
                          )}
                        </Col>
                      </Row>
                    </Col>
                  </>
                ) : (
                  ""
                )}
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        style={{
          fontSize: "12px",
        }}
        pauseOnHover
        theme="dark"
      />
    </React.Fragment>
  );
};

TicketingDetails.propTypes = {
  location: PropTypes.any,
  itemId: PropTypes.any,
  organizationId: PropTypes.any,
  partyName: PropTypes.any,
  ledgerLoading: PropTypes.any,
};

export default TicketingDetails;
